import { render, staticRenderFns } from "./SettingScaleInfo.vue?vue&type=template&id=30f8ac38&scoped=true&"
import script from "./SettingScaleInfo.vue?vue&type=script&lang=js&"
export * from "./SettingScaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingScaleInfo.vue?vue&type=style&index=0&id=30f8ac38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8ac38",
  null
  
)

export default component.exports